import _regeneratorRuntime from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import axios from 'axios';
import apiconfig from "../../apiconfig";
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, store, config, accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue, store = _ref.store;
            config = apiconfig[process.env.NODE_ENV];
            axios.defaults.baseURL = config.url;
            axios.defaults.timeout = 30000;
            accessToken = store.getters['user/getAccessToken'];

            if (accessToken) {
              axios.defaults.headers.common['X-Access-Token'] = accessToken;
            }

            Vue.prototype.$axios = axios;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();